var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', {
    staticClass: "pa-6",
    attrs: {
      "color": "grey lighten-3"
    }
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0"
  }, [_vm._v(_vm._s(_vm.form.price.unit.format()) + "원권")])], 1), _c('v-spacer'), _c('v-col', {
    staticClass: "purchase-amount__form",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-row', {
    staticClass: "ma-n1"
  }, [_c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    staticClass: "ma-n1",
    attrs: {
      "justify": "end",
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "tile": ""
    },
    on: {
      "click": _vm.decrease
    }
  }, [_c('v-icon', [_vm._v(" mdi-minus ")])], 1)], 1), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-text-field', {
    staticClass: "purchase-amount__form__data",
    attrs: {
      "type": "number",
      "flat": "",
      "solo": "",
      "hide-details": ""
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.count,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "count", $$v);
      },
      expression: "form.count"
    }
  })], 1), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "tile": ""
    },
    on: {
      "click": function click($event) {
        return _vm.increase(1);
      }
    }
  }, [_c('v-icon', [_vm._v(" mdi-plus ")])], 1)], 1)], 1)], 1), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    staticClass: "ma-n1",
    attrs: {
      "justify": "end",
      "align": "center"
    }
  }, [_vm._l([5, 10, 20, 40], function (value) {
    return [_c('v-col', {
      key: value,
      staticClass: "pa-1",
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-btn', {
      attrs: {
        "x-small": ""
      },
      on: {
        "click": function click($event) {
          return _vm.increase(value);
        }
      }
    }, [_vm._v(" +" + _vm._s(value) + "개 ")])], 1)];
  })], 2)], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }